import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';
import axios from 'axios'
// import {API_ENDPOINT} from "../../../constants/config";

async function getUser(userId) {
    let key = `uu_w_${userId}`;
    if (window[key] != undefined) {
        let u = window[key];
        return u;
    }
    let pld = (await axios.get(`/user/info/${userId}`)).data;
    window[key] = pld;
    return pld;
}

export default function UserNameSpan(props) {
    const {
        userId
    } = props;

    useEffect(() => {
        getUser(userId).then(x => {
            setUser(x);
        })
    }, [userId]);

    const [user, setUser] = useState(undefined);
    if (user == undefined) {
        return '...';
    }
    // let name = CommonHelper.getUserName(user);
    let name = user?.name || user?.email || '';

    return (
        <Wrapper>
            {name}
        </Wrapper>
    );
}

const Wrapper = styled.span`
  color: black;
  font-size: 12px;
  opacity: 0.7;
  padding: 3px;
  padding-left: 10px;
`;